<template>
  <div class="input-group">
    <select
      :value="filterOperator"
      class="form-select"
      style="max-width: 120px"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <input
      type="text"
      :value="displayValue"
      :id="computedFieldId"
      class="form-control"
      :placeholder="placeholder"
      :readonly="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      @input="onFilterValueChange($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "FilterFieldFile",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      return "";
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `filter-file-${this.field.key}`;
    },
  },
  methods: {
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
}
</style>

